// Brand colours live here rather than at the call site. InstoreForm.tsx forces `_checked` to `primary.midGrey` with
// three `sx={{ ".chakra-checkbox__control": ... }}` overrides only because the theme used to render Chakra stock blue.
// Those overrides are now redundant and can be deleted in a later pass.
export const Checkbox = {
  baseStyle: {
    control: {
      border: "1px solid",
      borderColor: "border.lightest",
      // 2px, not the 8px the input fields use: on a 16px box an 8px radius reads as a blob rather than a square.
      borderRadius: "2px",
      _checked: {
        bg: "primary.midGrey",
        borderColor: "primary.midGrey",
        _hover: {
          bg: "primary.midGrey",
          borderColor: "primary.midGrey",
        },
        // Nested inside `_checked` because Chakra's own `_checked._disabled` (gray.200) outranks a flat `_disabled`.
        _disabled: {
          bg: "grey.lightest",
          borderColor: "border.lightest",
          color: "text.disabled",
          opacity: 1,
        },
      },
      // One red across the whole form system, matching `inputChrome._invalid`.
      _invalid: {
        borderColor: "system.error",
      },
      _focus: {
        boxShadow: "0 0 0 2px var(--chakra-colors-system-focus)",
      },
      // Chakra's default `_disabled` is `opacity: 0.4`, which washes out the specified colours. Pinned to 1.
      _disabled: {
        bg: "grey.lightest",
        borderColor: "border.lightest",
        opacity: 1,
      },
    },
    label: {
      _invalid: {
        color: "system.error",
      },
      _disabled: {
        color: "text.disabled",
        opacity: 1,
      },
    },
    icon: {
      color: "primary.white",
    },
  },
  // 12px label across every size, matching the rest of the forms. Chakra's stock size recipes set the label font size,
  // so overriding `baseStyle` alone is not enough — `md` (the default) and `lg` (used on the styleguide) both need it.
  // Control geometry still comes from Chakra's own size recipes.
  sizes: {
    md: {
      label: {
        fontSize: "xs",
      },
    },
    lg: {
      label: {
        fontSize: "xs",
      },
    },
  },
}
